import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarPuesto from "./AgregarPuesto/AgregarPuesto";
import EditarPuesto from "./EditarPuesto/EditarPuesto";

moment.locale("es");

class Puestos extends Component {
  tableRef = null;
  state = {
    todosPuestos: [],
    loading: false,
    valor: 1,
    modalAgregarPuesto: false,
    modalEditarPuesto: false,
    modalEditarPuestoId: null,
  };

  consultarPuestos(params) {
    this.setState({ loading: true });
    axios
      .post(
        "puestos/selectTodasPuestos",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosPuestos: [] });
        } else {
          this.setState({
            todosPuestos: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  deshabilitarPuesto(value) {
    this.setState({ loading: true });
    axios
      .post(
        "puestos/deshabilitarPuesto",
        { puestoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Puesto deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  habilitarPuesto(value) {
    this.setState({ loading: true });
    axios
      .post(
        "puestos/habilitarPuesto",
        { puestoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Puesto habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  agregarPuesto() {
    this.setState({ modalAgregarPuesto: true });
  }

  cerrarAgregarPuesto() {
    this.setState({ modalAgregarPuesto: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarPuesto(id) {
    this.setState({ modalEditarPuesto: true, modalEditarPuestoId: id });
  }

  cerrarEditarPuesto() {
    this.setState({ modalEditarPuesto: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        width: "18%",
      },
      {
        title: "Tipo de Personal",
        dataIndex: "tipoPersonal",
        key: "tipoPersonal",
        width: "12%",
        render: (value) => value || "—",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        width: "20%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          if (value === 0) return <Tag color="red">Cancelado</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "10%",
        render: (value, record) => {
          let buttons = [];

          if (this.props.permisoEditarPuestos) {
            buttons.push(
              <Tooltip
                key={`tooltip-editar-${record._id}`}
                title="Editar Puesto"
                placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
              >
                <ButtonItem
                  key={`editar-${record._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarPuesto(record._id)}
                />
              </Tooltip>
            );
          }

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este puesto?"
                onConfirm={() => this.deshabilitarPuesto(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este puesto?"
                onConfirm={() => this.habilitarPuesto(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Puestos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Vigente", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              {this.props.permisoAgregarPuestos && (
                <ButtonItem
                  type="primary"
                  key="agregarPuesto"
                  onClick={this.agregarPuesto.bind(this)}
                >
                  Agregar Puesto
                </ButtonItem>
              )}
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarPuestos.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosPuestos}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"puestos" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (this.props.permisoEditarPuestos) {
                this.editarPuesto(record._id);
              }
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        {this.props.permisoAgregarPuestos && (
          <AgregarPuesto
            visible={this.state.modalAgregarPuesto}
            cerrarAgregarPuesto={this.cerrarAgregarPuesto.bind(this)}
          />
        )}
        {this.props.permisoEditarPuestos && (
          <EditarPuesto
            visible={this.state.modalEditarPuesto}
            puestoId={this.state.modalEditarPuestoId}
            cerrarEditarPuesto={this.cerrarEditarPuesto.bind(this)}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoAgregarPuestos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a9603dc8b7c192b16f8accf"
    )?.activado,
  permisoEditarPuestos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a9603e76102bd5076d2a3eb"
    )?.activado,
});

export default connect(mapStateToProps)(Puestos);